import { useQuery } from "@tanstack/react-query";

import { useCurrentCompanyId, useCurrentJobId } from "@/hooks";
import { httpClient } from "@/lib/http";
import { CandidacyComment, HttpResponse } from "@/types";

export function useGetCandidacyComments({ candidacyId }: { candidacyId: string }) {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  return useQuery({
    queryKey: ["candidacy_comments", currentCompanyId, currentJobId, candidacyId],
    queryFn: async () => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/candidacies/${candidacyId}/candidacy_comments`;
      const res = await httpClient.get<
        CandidacyComment[],
        HttpResponse<CandidacyComment[]>
      >(path);
      return res.data;
    },
  });
}
